import {Row} from "./row";

export class DeterminantRow extends Row {
  public jsonDeterminants: string = "";
}
